import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const userValidationResource = Resources.base.user.validationMessages;

export const getEditUserFormModelSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) =>
	z.object({
		name: z.string().nullish(),
		surname: z.string().nullish(),
		email: z
			.string()
			.email({ message: t(userValidationResource.emailFormat) })
			.optional()
			.nullable(),
		roles: z
			.preprocess((val) => {
				if (typeof val === "string") {
					return [val];
				}
				return val;
			}, z.array(z.string()))
			.optional()
			.nullable(),
		preselectedMarketId: z.number().int().nullish(),
		nickname: z.string().nullish(),
		publicPhoneNumber: z.string().nullish(),
	});

export type EditUserFormModel = z.infer<
	ReturnType<typeof getEditUserFormModelSchema>
>;
